{
  "alert.timezoneShift": "Time Shift Alert",
  "button.activate": "Activate",
  "button.addTemplate": "Add Template",
  "button.apply": "Apply",
  "button.archive": "Archive",
  "button.back": "Back",
  "button.cancel": "Cancel",
  "button.clear": "Clear",
  "button.close": "Close",
  "button.Close": "close",
  "button.confirm": "Confirm",
  "button.continue": "Continue",
  "button.dailyView": "Daily view details",
  "button.done": "Done",
  "button.downloadCandidates": "Download candidates",
  "button.downloadTemplate": "Download Template",
  "button.duplicate": "Duplicate",
  "button.edit": "Edit",
  "button.leave": "Leave",
  "button.logIn": "Log In",
  "button.logout": "Logout",
  "button.next": "Next",
  "button.previous": "Previous",
  "button.release": "Release",
  "button.remove": "Remove",
  "button.editOutage": "Edit Outage",
  "button.removeOutage": "Remove Outage",
  "button.retry": "Retry",
  "button.save": "Save",
  "button.showLess": "Show less",
  "button.showMore": "Show more",
  "button.stay": "Stay",
  "button.tryAgain": "Try Again",
  "button.viewHourlyAllocations": "View hourly allocations",
  "button.viewPool": "View Pool",
  "button.viewPoolConsumption": "View Configuration",
  "button.weeklyView": "Weekly view details",
  "button.ok": "OK",
  "button.delete": "Delete",
  "button.deactivate": "Deactivate",
  "button.copy": "Copy",
  "button.add_another_run_frequency": "Add another run frequency",
  "button.weekly": "Weekly",
  "button.everyday": "Daily (every day)",
  "button.unarchive": "Unarchive",
  "datepicker.error.end-date-before-start": "Date is before Start Date",
  "datepicker.error.exceeds-end-date": "Date exceeds the Pool End Date",
  "datepicker.error.invalid-date": "Invalid date",
  "datepicker.error.non-saturday-date": "Date is not a Saturday",
  "datepicker.error.non-sunday-date": "Date is not a Sunday",
  "datepicker.error.past-date": "Date is in the past",
  "datepicker.error.start-date-after-end": "Date is after End Date",
  "error.inalidspecialcharacter": "Pool Name cannot contains specail value.",
  "error.invalidCharacter": "Invalid character",
  "error.maxlength": "Character limit exceed. Max 250 character allowed.",
  "error.message.authentication": "There was a problem authenticating your account. Please try logging into the portal again.",
  "error.message.network": "Check your connection and try again.",
  "error.message.poolNameAlreadyExists": "Pool name already exists.",
  "error.message.alertpoolNameAlreadyExists": "Alert name already exists.",
  "error.message.templateNameAlreadyExists": "There is already an active template with this name. Please change the name to proceed.",
  "error.message.server": "Something went wrong.",
  "error.message.server.unsaved": "Something went wrong and your changes were not saved.",
  "error.message.submission": "Submission error. Please try again.",
  "error.message.invalidclientexammapping": "No Client is associated to some exams, either remove those or add respective client",
  "error.message.invalidDateExceptions": "Either Unselect the weekday(s) in 'Occurs on' OR remove the respective date(s) from date exceptions.",
  "error.message.invalidDateAdditions": "Either select the weekday(s) in 'Occurs on' OR add the respective date(s) in date additions.",
  "error.message.outOfRangeDateExceptions": "Remove any date which is outside the pool date range from Date exceptions.",
  "error.message.outOfRangeDateAdditions": "Remove any date which is outside the pool date range from date additions.",
  "error.title.network": "Network Error",
  "error.title.server": "Server Error",
  "error.title.invalidclientexammapping": "Client And Exam Mapping Error",
  "error.title.invalidDateExceptions": "Occurs On and Date Exceptions Mapping Error",
  "error.title.invalidDateAdditions": "Occurs On and Date Additions Mapping Error",
  "error.title.outOfRangeDateExceptions": "Out of Range Date Exceptions Mapping Error",
  "error.title.outOfRangeDateAdditions": "Out of Range Date Additions Mapping Error",
  "label.addPool.releaseAllOccurrencesOnDate": "Release all occurrences on date",
  "label.addPool.releaseOccurrences.interval.days": "days",
  "label.addPool.releaseOccurrences.interval.hours": "hours",
  "label.addPool.releaseOccurrences.releaseType.ends": "ends",
  "label.addPool.releaseOccurrences.releaseType.starts": "starts",
  "label.addPool.releaseOccurrencesByTime": "Release each occurrence individually",
  "label.addTemplate.copyFromPrevious": "Copy from a previous day",
  "label.addTemplate.remaining": "Remaining",
  "label.addTemplate.weekTotal": "Week total",
  "label.archived": "Archived",
  "label.aria.chartLegend": "Chart legend",
  "label.aria.chartShowingAppointmentCapacity": "Chart showing appointment capacity and registrations levels.",
  "label.aria.chartShowingAppointmentCapacity.seeBelow": "Chart showing appointment capacity and registrations levels.  See table below for details.",
  "label.aria.chartShowingAppointmentCapacity.selectedDate": "Chart showing appointment capacity and registrations levels for {0}.",
  "label.aria.chartShowingPoolAvailability": "Chart showing pool and queue availability.",
  "label.aria.chooseSetCapacityStrategy": "Choose Set Capacity Strategy",
  "label.aria.closeDialog": "close dialog",
  "label.aria.closeDrawer": "close drawer",
  "label.aria.closeHourlyAllocationDialog": "close hourly allocation dialog",
  "label.aria.datepicker.next.year": "Next year",
  "label.aria.datepicker.previous.year": "Previous year",
  "label.aria.helpLink": "OnVue Capacity help documentation",
  "label.aria.hideQueueCapacity": "Hide queue capacity",
  "label.aria.interval": "Interval",
  "label.aria.nextAction": "Show next action",
  "label.aria.nextMonth": "next month",
  "label.aria.openDailyDatepicker": "Open Daily Datepicker",
  "label.aria.openMonthlyDatepicker": "Open Monthly Datepicker",
  "label.aria.openYearlyDatepicker": "Open Yearly Datepicker",
  "label.aria.openWeeklyDatepicker": "Open Weekly Datepicker",
  "label.aria.previousAction": "Show previous action",
  "label.aria.previousMonth": "previous month",
  "label.aria.queue": "Queue",
  "label.aria.remove": "remove {0}",
  "label.aria.removeDailyException": "Remove daily exception",
  "label.aria.removeFilter": "Remove {0} filter",
  "label.aria.retryCalculations": "Retry get calculation request",
  "label.aria.scroll.backward": "Scroll content backward",
  "label.aria.scroll.forward": "Scroll content forward",
  "label.aria.selectATemplate": "Select a template",
  "label.aria.selectNextDay": "Select next day",
  "label.aria.selectNextMonth": "Select next month",
  "label.aria.selectNextYear": "Select next year",
  "label.aria.selectNextWeek": "Select next week",
  "label.aria.selectPreviousDay": "Select previous day",
  "label.aria.selectPreviousMonth": "Select previous month",
  "label.aria.selectPreviousYear": "Select previous year",
  "label.aria.selectPreviousStartDate": "Select previous start date",
  "label.aria.selectPreviousWeek": "Select previous week",
  "label.aria.selectedTemplate": "Selected Template: {0}",
  "label.aria.showQueueCapacity": "Show queue capacity",
  "label.aria.templateStatus": "Template Status",
  "label.aria.timescale": "Timescale",
  "label.auto-release.ends.plural": "{0} days, {1} hours before occurrence ends",
  "label.auto-release.ends.singular": "{0} day, {1} hours before occurrence ends",
  "label.auto-release.starts.plural": "{0} days, {1} hours before occurrence starts",
  "label.auto-release.starts.singular": "{0} day, {1} hours before occurrence starts",
  "label.client": "Client",
  "label.completed": "Completed",
  "label.dayOfWeek.friday": "Friday",
  "label.dayOfWeek.monday": "Monday",
  "label.dayOfWeek.saturday": "Saturday",
  "label.dayOfWeek.sunday": "Sunday",
  "label.dayOfWeek.thursday": "Thursday",
  "label.dayOfWeek.tuesday": "Tuesday",
  "label.dayOfWeek.wednesday": "Wednesday",
  "label.drawerHeader.of": "of",
  "label.drawerHeader.step": "Step",
  "label.editPool.automaticallyReleasePool": "Automatically release pool",
  "label.editPool.beforeOccurrence": "before occurrence",
  "label.editPool.dateAdditions": "Date additions",
  "label.editPool.dateExceptions": "Date exceptions",
  "label.editPool.drawer.title": "Edit Pool",
  "label.editPool.occursOn": "Occurs on",
  "label.editPool.resOrUnres": "Restriction",
  "label.editPool.allowQueue": "Allow Queue?",
  "label.editPool.releaseAllOccurrences": "Release all occurrences",
  "label.editPool.unrestrictPool": "Unrestricted pool",
  "label.editPool.restrictPool": "Restricted pool",
  "label.alertDetail.viewAllComments": "View all comments",
  "label.exam": "Exam",
  "label.filteredBy": "Filtered by:",
  "label.multiple": "Multiple",
  "label.no": "No",
  "label.none": "None",
  "label.open": "Open",
  "label.openAfter": "Open On or After",
  "label.openBefore": "Open On or Before",
  "label.pageStatus.retry": "Retry",
  "label.performedBy": "Performed by",
  "label.placeholder.end": "End",
  "label.placeholder.endDate": "End date",
  "label.placeholder.endPoolRange": "End pool range",
  "label.placeholder.endTime": "End time",
  "label.placeholder.moreFilters": "More Filters",
  "label.placeholder.openAfterDate": "Open on or after date",
  "label.placeholder.openBeforeDate": "Open on or before date",
  "label.placeholder.performedBy": "Performed by",
  "label.placeholder.queues": "Queues",
  "label.placeholder.search": "Search",
  "label.placeholder.searchActivity": "Search activity",
  "label.placeholder.searchClients": "Search clients",
  "label.placeholder.searchPoolNames": "Search pool names",
  "label.placeholder.searchByPoolNames": "Search by pool names",
  "label.placeholder.searchTemplates": "Search templates",
  "label.placeholder.searchUsers": "Search users",
  "label.placeholder.selectTimezone": "Select timezone",
  "label.placeholder.start": "Start",
  "label.placeholder.startDate": "Start date",
  "label.placeholder.startPoolRange": "Start pool range",
  "label.placeholder.startTime": "Start time",
  "label.placeholder.templateName": "Template name",
  "label.placeholder.templates": "Templates",
  "label.placeholder.totalAppointments": "Total appointments",
  "label.poolAvailability": "Pool Availability",
  "label.poolOccurrence.actionsMenu": "Actions menu for `{0}` pool occurrences",
  "label.poolOccurrence.dialogActionsMenu": "Actions menu for occurrences on `{0}`",
  "label.poolOccurrence.appointmentsPerDay": "Appointments per day",
  "label.poolOccurrence.edit": "Edit occurrence",
  "label.poolOccurrence.applypoolsettings": "Apply pool settings",
  "label.poolOccurrence.release": "Release occurrence",
  "label.poolOccurrence.toast": "Your changes have been saved.",
  "label.poolOccurrence.totalRegistrationsToday": "Total registrations today",
  "label.poolOccurrence.unrelease": "Unrelease occurrence",
  "label.poolOccurrence.restrictOccurrence": "Restricted occurrence",
  "label.poolOccurrence.unrestrictOccurrence": "Unrestricted occurrence",
  "label.poolOccurrence.viewPoolDetails": "View pool details",
  "label.poolOccurrence.unarchived": "Unarchive pool",
  "label.poolsOverview.createPool.toast.heading": "Pool created",
  "label.poolsOverview.createPool.toast.body": "`{0}` was created successfully.",
  "label.copyalertconfiguration.createPool.toast.heading": "Copy Configuration created",
  "label.poolsOverview.editPool": "Edit pool",
   "label.poolsOverview.duplicatePool": "Duplicate pool",
  "label.poolsOverview.openPoolsFor": "Open Pools for",
  "label.poolsOverview.actionsMenu": "Actions menu for `{0}` pool",
  "label.queue": "Queue",
  "label.type": "Type",
  "label.priority": "Priority",
  "label.startdate": "Start date",
  "label.enddate": "End date",
  "label.queueAvailability": "Queue Availability",
  "label.queueCapacity": "Queue Capacity",
  "label.released": "Released",
  "label.remove": "Remove",
  "label.removed": "Removed",
  "label.archive": "Archived",
  "label.scheduled": "Scheduled",
  "label.inactive": "Deactivated",
  "label.active": "Activated",
  "label.setCapacity.addTo": "Add to",
  "label.setCapacity.new": "New",
  "label.setCapacity.subtractFrom": "Subtract from",
  "label.setCapacity.templateApplied.toast.body": "`{0}` template has been applied.",
  "label.setCapacity.templateApplied.toast.heading": "Template applied",
  "label.status": "Status",
  "label.total": "total",
  "label.utc.timezone": "UTC 00:00",
  "label.weekTotal": "Week total",
  "label.yes": "Yes",
  "label.run_fequency": "Run frequency",
  "label.time": "Time",
  "label.prioritys": "Priority",
  "label.critical": "Critical",
  "label.days": "Days",
  "label.find_pool": "Search Pool",
  "label.queues": "Queue",
  "label.date": "Date",
  "label.alert/hours": "Alerts hours",
  "label.all/hours": "All hours",
  "label.pool_date_range": "Pool Date range",
  "label.pool_time_range": "Consider individual Occurrence time range",
  "label.add_another_time_range": "Add another time range",
  "label.threshold & priority": "Threshold & Priority",
  "label.add_another_threshold_Priority": "Add another threshold & Priority",
  "label.Create": "Create",
  "label.calendar": "Calendar",
  "label.alertrange": "Alert Range",
  "label.currentselection": "Currently Showing",
  "label.alerts": "Alert Name",
  "label.calenderBlankdetails": "This Date is outside the alert range",
  "label.alertsconfiguration": "Create alert configuration",
  "label.copyalertsconfiguration": "Copy alert configuration",
  "label.editconfiguration": "Edit alert configuration",
  "label.confirm": "Confirm Selection",
  "messages.value": "Enter value between 1 to  100%",
  "messages.confirmation": "Are you sure you want to resolve the alert?",
  "message.warning": "Select valid value.",
  "messages.weekdays": "Select Weekdays!",
  "messages.invalid": "Invalid Value!",
  "messages.errorMessges": "Enter Numeric Value Between 1 to 100%",
  "message.addPool.capacity.instructions": "Select start and end times to enter capacity.",
  "message.addTemplate.copyOf": "Copy of {0}",
  "message.addTemplate.created": "`{0}` was created successfully.",
  "message.addOutage.created": "Outage created successfully.",
  "message.editOutage.updated": "Outage has been updated.",
  "message.editOutage.deleted": "Outage has been deleted.",
  "message.addTemplate.updated": "`{0}` has been updated.",
  "message.addTemplate.activated": "`{0}` has been activated.",
  "message.allPools.noPools": "No pools available to display",
  "message.alerts": "No Comments available to display",
  "message.allocations.noAllocations": "No allocations available to display",
  "message.archivePool.confirmation": "Are you sure you want to archive the pool ‘{0}’?",
  "message.capacity.reset": "Reset capacity changes",
  "message.capacity.save": "",
  "message.capacity.unsaved.plural": "You have <b>{0} unsaved changes</b>",
  "message.capacity.unsaved.singular": "You have <b>{0} unsaved change</b>",
  "message.capacity.uploaded": "Capacity file uploaded successfully",
  "message.capacityconfirmation":" This action will undo the  file uploaded and restore the previous capacity values.",
   "message.capacityconfirmationmessage":" Do you want to continue?",
  "message.changes.saved": "Your changes have been saved.",
  "message.clientMustBeSelected": "A Client must be selected before an Exam filter can be applied",
  "message.clients.noClients": "No clients available to display",
  "message.file.downloaded": "File downloaded successfully",
  "title.file.delete": "Undo successful",
  "message.file.undomessage": "Your changes have been saved.",
  "message.filteredClients.plural": "Only showing exams for <b>{0} clients</b>",
  "message.filteredClients.singular": "Only showing exams for <b>{0} client</b>",
  "message.leavePage.confirmation": "Are you sure you want to leave this page? You have unsaved edits that will be lost.",
  "message.loading": "Loading...",
  "message.alertoutofoccurance": "Are you sure you want to modify the capacity of the time slot(s) that are outside the occurrence time range? Doing so will update the occurrence start/end time.",
  "message.noResultsToDisplay": "No results to display",
  "message.occurrence.restricted": "Occurrence is restricted",
  "message.occurrence.unrestricted": "Occurrence is unrestricted",
  "message.outage.noOutage": "No outages available to display",
  "message.alerts.noAlerts": "No alerts available to display",
  "message.alerts.noThresholdData": "No threshold available to display",
  "message.alerts.noRunFrequencyData": "No run frequency available to display",
  "message.poolconsumptions.noPoolConsumption": "No configuration was found for this Pool.",
  "message.pageNotFound": "Please try again or return to the home page.",
  "message.pageStatus.error": "There was a problem loading the content. Please try again.",
  "message.pool.releaseAllOccurrences": "  Are you sure you want to release all occurrences for the pool ‘{0}’? All other changes will be saved.",
  "message.pool.restricted": "Pool is restricted",
  "message.pool.unrestricted": "Pool is unrestricted",
  "message.poolDetails.tooltip.appointments": "Capacity assigned to each occurrence when the pool was set up, capacity for individual occurrences may vary.",
  "message.poolOccurrence.noOccurrences": "No occurrences available to display",
  "message.poolOccurrence.selectDateAbove": "Select a date above to view occurrences",
  "message.pools.dateRangeFilter": "Filter open pool ranges by date. Select either to filter pools that are open before or after a date, or select both to create a range.",
  "message.pools.noOpenPools": "No open pools available this month",
  "message.recentActivity.noActivities": "No activities available to display",
  "message.removeOccurrence.confirmation": "Are you sure you want to remove this occurrence? This date will be added to the pool’s date exceptions.",
  "message.removeOutage.confirmation": "Are you sure you want to remove this outage?",
  "message.removeTemplate.confirmation": "Are you sure you want to archive this template?",
  "message.setCapacity.bulkEdit.capacityInstructions": "Set capacity for hourly time frames by defining a new value or by adding or subtracting from the original value.",
  "message.setCapacity.bulkEdit.dateRangeInstructions": "Time range repeats for each day within specified date range.",
  "message.setCapacity.fileUpload.additional": "To upload another file, drag and drop your file here or",
  "message.setCapacity.fileUpload.browseFiles": "browse files",
  "message.setCapacity.fileUpload.cancel": "cancel upload",
  "message.setCapacity.fileUpload.dragAndDrop": "Drag and drop your file here or",
  "message.setCapacity.fileUpload.error": "There was an error processing your file. Please try again.",
  "message.setCapacity.fileUpload.loading": "Uploading...",
  "message.setCapacity.fileUpload.success": "successfully browsed!",
  "message.setCapacity.fileUpload.uploaded": "successfully uploaded!",
  "message.setCapacity.fileUpload.uploadCapacityFile": "Upload capacity file",
  "message.systemTimeout.countdown": "Your session will expire in {0}. Select ‘Continue’ to keep working, or ‘Logout’ to exit now.",
  "message.template.activated": "`{0}` has been activated.",
  "message.template.archived": "`{0}` has been archived.",
  "message.poolconsumption.activate": "`{0}` was successfully activated.",
  "message.poolconsumption.deactivate": "`{0}` was successfully deactivated.",
  "message.poolconsumption.delete": "`{0}` was successfully deleted.",
  "message.poolconsumption.create":"`{0}` was created successfully.",
  "message.template.noTemplates": "No templates available to display",
  "message.occurrence.restrict.dialog.title": "Occurrence Edit Restriction",
  "message.occurrence.restrict.dialog": "Can't edit more than 15 occurrences",
  "message.poolconsumption.deactivate.confirmation": "Are you sure you want to deactivate `{0}` configuration.",
  "message.poolconsumption.delete.confirmation": "Are you sure you want to delete `{0}` configuration. This action cannot be undone",
  "message.poolconsumption.copy.modal": "What would you like to copy from `{0}` configuration?",
  "message.alertDetails.comments.modal": "Comments",
  "message.pool.change.poolname.modal": "There is already an open or scheduled pool with the same name. Please change the name to unarchive the pool.",
  "occurrence.edit.dialog.heading": "Edit {0}",
  "occurrence.edit.dialog.heading.date": "Edit {0} - {1}",
  "occurrence.remove.dialog.heading": "Remove {0} occurrence?",
  "occurrence.remove.dialog.heading.date": "Remove {0} - {1} occurrence?",
  "outage.remove.dialog.heading": "Remove Outage",
  "template.remove.dialog.heading": "Archive Template",
  "poolconsumption.delete.dialog.heading": "Delete `{0}`",
  "poolconsumption.deactivate.dialog.heading": "Deactivate `{0}`",
  "option.allQueues": "All Queues",
  "option.all": "All",
  "page.title": "OnVUE Capacity",
  "paginator.firstPage": "First page",
  "paginator.itemsPerPage": "Rows per page",
  "paginator.lastPage": "Last page",
  "paginator.nextPage": "Next page",
  "paginator.ofLabel": "of",
  "paginator.perPageLabel": "Rows per page",
  "paginator.previousPage": "Previous page",
  "placeholder.datepicker": "mm/dd/yyyy",
  "privacy-banner.iUnderstand": "I understand",
  "privacy-banner.learnMore": "Learn more",
  "privacy-banner.message": "We use cookies to provide an optimal experience. By continuing to use this application you are consenting to our use of cookies.",
  "privacy-banner.title": "Privacy and cookies",
  "radioButton.bulkEdit.addSubtract": "Add or subtract from current hourly capacity",
  "radioButton.bulkEdit.hourlyCapacity": "Set new hourly capacity",
  "subtitle.beingDownloaded": "Your file is being downloaded now.",
  "subtitle.errorDownloading": "No appointment records found.",
  "subtitle.generatingDownload": "Your file is being generated.",
  "subtitle.pleaseWait": "Please don’t leave or refresh the page.",
  "table.caption.allClients": "Clients, column headings with buttons are sortable",
  "table.caption.allAlerts": "Alerts, column headings with buttons are sortable",
  "table.caption.allPoolConsumption": "Pool Consumption, column headings with buttons are sortable",
  "table.caption.allPools": "Pools, column headings with buttons are sortable",
  "table.caption.appointmentAllocation": "Appointment allocation",
  "table.caption.apptRecentActivity": "Appointments recent activity, column headings with buttons are sortable",
  "table.caption.dailyAppointments": "Daily appointment capacity",
  "table.caption.hourlyAllocation": "Hourly allocation",
  "table.caption.occurrences": "Pool occurrences",
  "table.caption.occurrences.sortable": "Pool occurrences, column headings with buttons are sortable",
  "table.caption.openPools": "Open pools, column headings with buttons are sortable",
  "table.caption.poolsRecentActivity": "Pools recent activity, column headings with buttons are sortable",
  "table.caption.templates": "Templates, column headings with buttons are sortable",
  "table.heading.actions": "Actions",
  "table.heading.occurrence": "Occurrence & Pool Restriction",
  "table.heading.occurrence.abbr": "Occ. / Pool <br>Restriction",
  "template.status.active": "Active",
  "template.status.all": "All",
  "template.status.archived": "Archived",
  "timezone.america/chicago.change": "The America/Chicago time zone shifts from UTC{0} to UTC{1} on {2}.",
  "timezone.america/chicago.daylight.abbr": "CDT",
  "timezone.america/chicago.iana.display": "America/Chicago",
  "timezone.america/chicago.standard.abbr": "CST",
  "timezone.america/new_york.change": "The America/New York time zone shifts from UTC{0} to UTC{1} on {2}.",
  "timezone.america/new_york.daylight.abbr": "EDT",
  "timezone.america/new_york.iana.display": "America/New York",
  "timezone.america/new_york.standard.abbr": "EST",
  "timezone.asia/calcutta.change": "The Asia/Calcutta time zone shifts from UTC{0} to UTC{1} on {2}.",
  "timezone.asia/calcutta.iana.display": "Asia/Calcutta",
  "timezone.asia/calcutta.standard.abbr": "IST",
  "timezone.australia/melbourne.change": "The Australia/Melbourne time zone shifts from UTC{0} to UTC{1} on {2}.",
  "timezone.australia/melbourne.daylight.abbr": "AEDT",
  "timezone.australia/melbourne.iana.display": "Australia/Melbourne",
  "timezone.australia/melbourne.standard.abbr": "AEST",
  "timezone.europe/london.change": "The Europe/London time zone shifts from UTC{0} to UTC{1} on {2}.",
  "timezone.europe/london.daylight.abbr": "GMT",
  "timezone.europe/london.iana.display": "Europe/London",
  "timezone.europe/london.standard.abbr": "BST",
  "title.activity": "Activity",
  "title.alertdetils": "Alerts Details | Calendar",
  "title.addException": "Add exception",
  "title.addAnotherOutage": "Add another outage",
  "title.addOutage": "Add Outage",
  "title.addPool": "Add Pool",
  "title.addTemplate": "Add Template",
  "title.allDay": "All day",
  "title.allPools": "All Pools",
  "title.application": "Application",
  "title.applicationName": "OnVUE Capacity",
  "title.applyCapacityTemplate": "Apply capacity template",
  "title.appointmentAllocation": "Appointment allocation",
  "title.appointmentCapacity": "Appointment Capacity",
  "title.appointmentManagement": "Appointment Management",
  "title.appointmentsPerDay": "Appointments per day",
  "title.archivePool": "Archive Pool",
  "title.authenticationProblem": "Authentication Problem",
  "title.pooltitle": "Pool A(RES)",
  "title.net/queue": "Net Queue Ava. ",
  "title.pool/Availablility": "Pool Ava. ",
  "title.pool/utilization": "Pool Utilization: ",
  "title.autoRelease": "Auto Release",
  "title.availability": "Availability",
  "title.bulkEdit": "Bulk edit",
  "title.candidateCode": "Candidate code",
  "title.capacity": "Capacity",
  "title.Allow": "ALLOW QUEUE",
  "title.resUnres": "Restricted",
  "title.capacityFileUpload": "Capacity file upload",
  "title.capacityUpdated": "Capacity updated",
  "title.capacityUploaded": "Capacity uploaded",
  "title.client": "Client",
  "title.clients": "Clients",
  "title.comment": "Add Comment (Max 250 characters)",
  "title.alert.resolve.comment": "Comment",
  "title.createdBy": "Created By",
  "title.createdOn": "Created On",
  "title.resolvedBy": "Resolved By",
  "title.resolvedOn": "Resolved On",
  "title.resolve": "Resolve",
  "title.threshold": "Threshold",
  "title.runFrequency": "Run frequency",
  "title.email": "Email",
  "title.critical": "Critical",
  "title.daily": "Daily",
  "title.dailyAllocation": "Daily allocation",
  "title.dailyTimeExceptions": "Daily time exceptions",
  "title.balancecapacity": "Balance capacity",
  "title.date": "Date",
  "title.dateCreated": "Date Created",
  "title.dateRange": "Date range",
  "title.confirmationheader":"Undo-",
  "title.datePickerMonthYear": "Month/Year",
  "title.dateTimeRange": "Daily time range",
  "title.day": "Day",
  "title.defaultAppointmentsPerDay": "Default appointments per day",
  "title.details": "Details",
  "title.downloading": "Downloading",
  "title.editTemplate": "Edit Template",
  "title.activeTemplate": "Activate Template",
  "title.endDate": "End Date",
  "title.error": "The file cannot be downloaded.",
  "title.exams": "Exams",
  "title.fifteenMinutes": "15 min",
  "title.fileDownload": "File Download",
  "title.generating": "Generating",
  "title.hourlyAllocation": "hourly allocation (UTC)",
  "title.hourlyAllocations.friday": "Friday hourly allocations",
  "title.hourlyAllocations.monday": "Monday hourly allocations",
  "title.hourlyAllocations.saturday": "Saturday hourly allocations",
  "title.hourlyAllocations.sunday": "Sunday hourly allocations",
  "title.hourlyAllocations.thursday": "Thursday hourly allocations",
  "title.hourlyAllocations.tuesday": "Tuesday hourly allocations",
  "title.hourlyAllocations.wednesday": "Wednesday hourly allocations",
  "title.loading": "Loading",
  "title.logic": "Logic",
  "title.monthly": "Monthly",
  "title.occurrences": "Occurrences",
  "title.oneDay": "1 day",
  "title.oneHour": "1 hour",
  "title.overview": "Overview",
  "title.pageNotFound": "Page not found!",
  "title.performedBy": "Performed by",
  "title.pool": "Pool",
  "title.poolCapacity": "Pool Capacity",
  "title.poolDetails": "Pool Details",
  "title.configurationDetails": "Configuration Details",
  "title.summary": "Summary",
  "title.poolName": "Pool Name",
  "title.pools": "Pools",
  "title.pools.occurrences": "Occurrences",
  "title.pools.occurrences.date": "Occurrences for {0}",
  "title.queue": "Queue",
  "title.queues": "Queues",
  "title.recentActivity": "Recent Activity",
  "title.registrations": "Registrations",
  "title.registrations.abbreviated": "Reg.",
  "title.restricted": "Restricted",
  "title.restricted.abbreviated": "Res.",
  "title.restriction": "Restriction",
  "title.saving": "Saving",
  "title.deleting": "Deleting",
  "title.setCapacity": "Set Capacity",
  "title.sixHours": "6 hours",
  "title.startDate": "Start Date",
  "title.status": "Status",
  "title.systemTimeout": "System Timeout",
  "title.template": "Template",
  "title.template.activated": "Template activated",
  "title.poolconsumption.activate": "Configuration activated",
  "title.poolconsumption.delete": "Configuration deleted",
  "title.poolconsumption.deactivate": "Configuration deactivated",
  "title.poolconsumption.create": "Configuration created",
  "title.template.archived": "Template archived",
  "title.templateCreated": "Template created",
  "title.templateActivated": "Template activated",
  "title.outageCreated": "Outage created",
  "title.outageUpdated": "Outage updated",
  "title.outageDeleted": "Outage deleted",
  "title.templateName": "Template name",
  "title.templateUpdated": "Template updated",
  "title.templates": "Templates",
  "title.time": "Time",
  "title.alertDetails": "Alert Details",
  "title.alertName": "Alert Name",
  "title.alertType": "Alert Type",
  "title.priority": "Priority",
  "title.alertDateRange": "Alert Date Range",
  "title.timeRange": "Time range",
  "title.timeRange.utc": "Time Range (UTC)",
  "title.alertTimeRange.utc": "Alert Time Range (UTC)",
  "title.IndividualalertTimeRange" : "Individual Occurrence time range",
  "title.time.utc": "Time (UTC)",
  "title.total": "Total",
  "title.totalCapacity": "Total capacity",
  "title.unrestricted": "Unrestricted",
  "title.unsavedChanges": "Unsaved Changes",
  "title.utc": "UTC",
  "title.utilization": "Utilization",
  "title.viewPool": "View Pool",
  "title.weekOf": "Week {0}",
  "title.weekly": "Weekly",
  "title.outages": "Outages",
  "title.outagesmonthly": "Monthly",
  "title.outagesyearly": "Yearly",
  "title.outagename": "Outage name",
  "title.alerts": "Alerts",
  "title.poolconsumption": "Pool Consumption",
  "title.poolconsumptionpage": "Configurations | Pool Consumption",
  "title.configurations": "Configurations",
  "title.search": "Search",
  "title.reset": "Reset",
  "title.setEqualAllocation": "Set equal allocation",
  "title.Updatedcapacity": "Update Capacity",
  "title.pastHourCapacityNotUpdated": "System has not updated the capacity for past hours.",
  "messages.pastHourCurrentcapacity": "System has updated the capacity as 0 for those slots where bulk edit action might have caused negative value Also, System has not updated the capacity for past hours.",
  "messages.pastHourfuturecapacity": "System has updated the capacity as 0 for those slots where bulk edit action might have caused negative value.",
  "toast.heading.editPool.archived": "Pool archived",
  "toast.heading.editPool.unarchived": "Pool unarchived",
  "toast.heading.editPool.released": "All occurrences released",
  "toast.heading.editPool.updated": "Pool updated",
  "toast.heading.editalert.updated": "Configuration updated",
  "toast.heading.occurrence.released": "Occurrence released",
  "toast.heading.occurrence.removed": "Occurrence removed",
  "toast.heading.occurrence.applypoolsettings": "Occurrence updated",
  "toast.heading.occurrence.unreleased": "Occurrence unreleased",
  "toast.heading.occurrence.updated": "Occurrence updated",
  "toast.message.editPool.archived": "Pool `{0}` has been archived.",
  "toast.message.editPool.unarchived": "Pool `{0}` has been unarchived.",
  "toast.message.editPool.released": "All occurrences successfully released for pool `{0}`.",
  "toast.message.editPool.updated": "Pool `{0}` has been updated.",
  "toast.message.editalertpool.updated": "Configuration `{0}` has been updated.",
  "tooltip.message.capacity.unsaved": "Only {0} cells can be modified at a time",
  "tooltip.messages.activestatusofOcc": "Inactive Occ hour",
  "tooltip.messages.activestatusofAlert": "Inactive Alert hour",
  "tooltip.message.occurrence.restricted": "Occurrence is restricted",
  "tooltip.message.occurrence.unrestricted": "Occurrence is unrestricted",
  "tooltip.message.pool.restricted": "Pool is restricted",
  "tooltip.message.pool.unrestricted": "Pool is unrestricted",
  "tooltip.message.registrations": "Number of existing registrations that meet the pool criteria. These registrations will not be enrolled into the pool once the pool is created.",
  "tooltip.message.poolconsumption.inactive": "This alert configuration is deactivated",
  "tooltip.message.override": "Schedule Override: This occurrence doesn't inherit active hours, capacity or occurrence restriction from the Pool Settings. It needs to be modified individually or reset using 'Apply pool setting'.",
  "tooltip.message.openunestrictedpool": "Checking the 'Allow Queue ?' checkbox shall allow the candidates to register into the general queue for any timeslot with in the occurrence hours for which there is no availability left in the occurrence.",
  "tooltip.message.inativealerthour": "This time slot is outside the alert time range but within the occurrence time range. Modifying the capacity will not impact occurrence and/or alert time range.'.",
  "tooltip.message.inativeOccurhour": "This time slot is outside the occurrence time range. Modifying the capacity will also modify the occurrence start/end time.",
  "tooltip.message.balancecapacity": "Checking this checkbox shall flatten out the hour , meaning all the 15-minute slots with-in an hour shall have same capacity.",
  "tooltip.message.inativeOccuranceHour": "This time slot is outside the occurrence time range. Modifying the capacity will also modify the occurrence start/end time.'.",
  "tooltip.message.restrict": "Prevent pooled client(s)/exam(s) candidates from registering on a non-occurrence day.",
  "tooltip.message.unrestrict": "Allow pooled client(s)/exam(s) candidates to register in the general queue on a non-occurrence day.",
  "tooltip.message.pool.restrictedOccurrence": "Restricted Occurrence. Prevent candidates from registering outside the occurrence active hours.",
  "tooltop.message.pool.unrestrictedOccurrence": "Unrestricted Occurence. Allow candidates to register in the general queue outside occurence active hours.",
  "tooltop.message.occurrence.viewoccurrencerestriction": "Click to view restriction.",
  "tooltop.message.client.viewexams": "Click to view exams",
  "tooltop.message.client.viewpools": "Click to view pools",
  "tooltop.message.pool.invalidexam": "Please add the client or remove this exam",
  "tooltop.message.pool.invalidDateExceptions": "Respective day is not selected in 'Occurs On', so remove this date from 'Date exceptions' to proceed.",
  "tooltop.message.pool.invalidDateAdditions": "Respective day is selected in 'Occurs On', Either unselect the day from Occurs on or remove all the dates falling on that day from Date additions.",
  "tooltop.message.alert.threshold": "Maximum of 4 threshold allowed",
  "tooltop.message.alert.runfrequency": "Maximum of 10 Run-frequency allowed",
  "tooltop.message.pool.OutOfRangeDateExceptions": "This date is outside the pool date range.",
  "tooltop.message.pool.OutOfRangeDateAdditions": "This date is outside the pool date range.",
  "tooltop.message.inlineCapacityEdit.PastHourCapacity": "Editing past hour capacity is not allowed."
}